import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ReceivedRequest, RequestingParams } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getAllReceivedRequests = createAsyncThunk(
  "feedback/requests/received",
  async (requestingData: RequestingParams, storeActions) => {
    const url = `api/v1/user/feedback-requests/received` + requestingData.requestParams;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const allReceivedRequestsSlice = createSlice({
  name: "allRequestsReceived",
  initialState: {
    status: null as number | null,
    text: null as string | null,
    data: null as Array<ReceivedRequest> | null,
    loading: false as boolean,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllReceivedRequests.fulfilled, (state, action) => {
      state.status = action.payload.status;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
      state.loading = false;
    });
    builder.addCase(getAllReceivedRequests.pending, (state) => {
      state.loading = true;
      state.status = null;
      state.text = null;
      state.data = null;
    });
    builder.addCase(getAllReceivedRequests.rejected, (state) => {
      state.status = 503;
      state.text = null;
      state.data = null;
      state.loading = false;
    });
  },
});

export const { clearData } = allReceivedRequestsSlice.actions;

export default allReceivedRequestsSlice;
